import Notifications from './components/notifications';
import definition from './intl.json';
import intl from 'preact-i18n';

export default intl(Notifications, {
	scope: 'notifications',
	definition
});
